import axios from "../../api/garbageCan";
import ITrash from "../../models/garbage can/response/trash";
import Auth from "../auth/AuthService";

import ApiResponse from "../../models/apiResponse";
import IGarbageCan from "../../models/garbage can/garbageCan";

class SensorService {
    PostSensors = async (
        selectedBuilding: string,
        selectedFloor: string,
        selectedRoom: string,
        garbageCans: IGarbageCan[]
    ) => {
        const url = "/residual-material/total";
        const request = {
            selectedBuilding,
            selectedFloor,
            selectedRoom,
            garbageCans,
        };
        return (
            await axios.post(url, request, {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };
    GetTotalResidualMaterial = async (
        companyId: number,
        startTime: Date,
        endTime: Date
    ) => {
        const url = "/residual-material/total";
        const query = axios.get<ApiResponse>(url, {
            headers: { Authorization: Auth.guid },
            params: { companyId, startTime, endTime },
        });
        const response = (await query).data;
        return response.data as ITrash;
    };

    GetResidualMaterialPerFloor = async (
        companyId: number,
        startTime: Date,
        endTime: Date
    ) => {
        const url = "/residual-material/GetResidualMaterialPerFloor";
        const query = axios.get<ApiResponse>(url, {
            headers: { Authorization: Auth.guid },
            params: { companyId, startTime, endTime },
        });
        const response = (await query).data;
        return response.data as Map<string, number>;
    };

    GetResidualMaterialPerMonth = async (
        companyId: number,
        startTime: Date,
        endTime: Date
    ) => {
        const url = "/residual-material/GetResidualMaterialPerMonth";
        const query = axios.get<ApiResponse>(url, {
            headers: { Authorization: Auth.guid },
            params: { companyId, startTime, endTime },
        });
        const response = (await query).data;
        return response.data as Map<string, number>;
    };

    GetQuantityPerMonth = async (
        companyId: number,
        startTime: Date,
        endTime: Date
    ) => {
        const url = "/residual-material/GetQuantityPerMonth";
        const query = axios.get<ApiResponse>(url, {
            headers: { Authorization: Auth.guid },
            params: { companyId, startTime, endTime },
        });
        const response = (await query).data;
        return response.data as Map<string, number>;
    };

    GetCostsPerMonth = async (
        companyId: number,
        startTime: Date,
        endTime: Date
    ) => {
        const url = "/residual-material/GetCostsPerMonth";
        const query = axios.get<ApiResponse>(url, {
            headers: { Authorization: Auth.guid },
            params: { companyId, startTime, endTime },
        });
        const response = (await query).data;
        return response.data as Map<string, number>;
    };
}

export default new SensorService();
